export enum Steps {
  WHAT_KIND_OF_JOURNEY = "What kind of Journey",
  WHAT_KIND_OF_JOURNEY_IVF_DECISION = "What kind of journey IVF decision",
  WHERE_ARE_YOU_IN_JOURNEY = "Where are you in journey",
  WHERE_ARE_YOU_IN_JOURNEY_NOW = "Where are you in your journey now",
  WHERE_ARE_YOU_IN_JOURNEY_DECISION = "Where are you in journey decision",
  WHERE_ARE_YOU_IN_JOURNEY_IVF_DECISION = "Where are you in journey IVF decision",
  NAME_OF_AGENCY = "Name of agency",
  NAME_OF_CLINIC_AGENCY_ATTORNEY = "Name of clinic agency attorney",
  WHAT_KIND_OF_PROVIDER = "What kind of provider",
  WHAT_KIND_OF_PROVIDER_FOR_IUI = "What kind of provider for IUI",
  WHAT_KIND_OF_PROVIDER_DECISION = "What kind of provider decision",
  NAME_OF_CLINIC = "Name of clinic",
  NAME_OF_OBGYN = "Name of OBGYN",
  MOST_HELPFUL = "What would be most helpful",
  US_MOST_HELPFUL = "US or non US",
  MOST_HELPFUL_DECISION = "What would be most helpful decision",
  WHAT_KIND_OF_JOURNEY_SHARE_BACKGROUND_DECISION = "What kind of journey share background decision",
  PERSON_OF_COLOR_SHARE_BACKGROUND = "Person of color share background",
  SOCIAL_DETERMINANTS_OF_HEALTH = "Social determinants of health",
  SOCIAL_DETERMINANTS_OF_HEALTH_DECISION = "Social determinants of health decision",
  IVF_INFORMATION = "IVF information",
  IVF_TREATMENT_START = "When are you starting fertility testing?",
  GESTATIONAL_CARRIER_DECISION = "Gestational carrier decision",
  GESTATIONAL_CARRIER_IN_MIND = "Gestational carrier in mind",
  GESTATIONAL_CARRIER_DELIVERY = "Gestational carrier delivery",
  DO_ANY_APPLY = "Do any apply",
  DO_ANY_APPLY_CHECK_IN_DECISION = "DO_ANY_APPLY_CHECK_IN_DECISION",
  PARTNER_DO_ANY_APPLY = "Partner do any apply",
  PRESERVATION = "Preservation",
  ANYTHING_ELSE = "Anything else",
  ANYTHING_ELSE_SENSITIVE_SCENARIO = "Anything else sensitive scenario",
  PROCESS_CREATE_CARROT_PLAN = "Process create Carrot Plan",
  MESSAGE_WONDERFUL = "Message wonderful",
  PRESERVATION_MEDICAL_RECORDS_CONSENT = "Fertility preservation medical records consent",
  PRESERVATION_MED_ENTRY_DECISION = "Medical entry decision – fertility preservation",
  ASSISTED_REPRODUCTION_MED_ENTRY_DECISION = "Medical entry decision – assisted reproduction",
  ATTEMPTING_TO_GET_PREGNANT_MED_ENTRY_DECISION = "Medical entry decision – trying to get pregnant",
  CURRENTLY_PREGNANT_MED_ENTRY_DECISION = "Medical entry decision – currently pregnant",
  EXPLORING_MED_ENTRY_DECISION = "Medical entry decision – exploring",
  MENOPAUSE_MED_ENTRY_DECISION = "Medical entry decision – menopause",
  LOW_TESTOSTERONE_MED_ENTRY_DECISION = "Medical entry decision – low testosterone",
  SHOW_MEDICAL_QUESTIONS_DECISION = "Show medical questions decision",
  AMAB_AFAB_MEDICAL_PREFERENCE_STEP = "AMAB or AFAB Medical Questions Preference Step",
  MEDICAL_PREFERENCE_STEP = "General Medical Questions Preference Step",
  ASSISTED_REPRODUCTION = "Assisted reproduction",
  DUE_DATE = "Due date",
  DELIVERY_DATE = "Delivery (birth) date",
  NUMBER_OF_CHILDREN = "The number of children a member has",
  ART_MEDICATION_START_DATE = "The date someone started assisted reproduction medication",
  PRESERVATION_MEDICATION_START_DATE = "The date someone started preservation medication",
  PRESERVATION_CYCLE_TESTING = "Testing for the egg or embryo preservation cycle timing",
  EGG_RETRIEVAL_DATE = "When did egg retrieval take place",
  WHERE_ARE_YOU_IN_JOURNEY_PRESERVATION_DECISION = "Where are you in journey preservation decision",
  RECENTLY_RECEIVED_PRESERVATION_DECISION = "Recently received preservation decision",
  JOURNEY_STAGE_DECISION = "Journey stage decision",
  ARE_YOU_STILL_IN_THIS_PHASE = "Are you still in this phase?",
  SHOW_MEDICAL_PREFERENCE_DECISION = "Show medical preference decision",
  GOAL_TIMEFRAME = "Goal timeframe",
  GOAL_TIMEFRAME_DECISION = "Goal timeframe decision"
}
